import imageUrl from "@/utils/imageUrl";
import { Button, Radio } from "antd";
import { useCallback, useState } from "react";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

function MaterialFileTypeSelectModal({ files, pin, onOk, ...props }) {
  const [fileType, setFileType] = useState(files?.[0]?.file_format);

  const onChange = useCallback((evt) => {
    setFileType(evt.target.value);
  }, []);

  const onSubmit = useCallback(() => {
    onOk && onOk(files.find((file) => file?.file_format === fileType));
  }, [fileType, files, onOk]);

  return (
    <HBModal
      className={styles.modal}
      title="选择文件格式"
      width={480}
      footer={null}
      {...props}
    >
      <div className={styles.container}>
        <div className={styles.info}>
          <div className={styles.img}>
            <img src={imageUrl(pin?.file, { width: 50 })} alt={pin?.raw_text} />
          </div>
          <div className={styles.desc}>
            <div className={styles.title}>{pin?.raw_text}</div>
            <div className={styles.subtitle}>
              <span>{fileType?.toUpperCase()}</span>(当前素材存在多个格式,
              选择你编辑需要的格式)
            </div>
          </div>
        </div>
      </div>
      <Radio.Group
        className={styles.radio}
        onChange={onChange}
        value={fileType}
      >
        {files.map((file, index) => {
          const format = file?.file_format;
          return (
            <Radio value={format} key={index}>
              {format?.toUpperCase()}
            </Radio>
          );
        })}
      </Radio.Group>
      <div className={styles.footer}>
        <Button className={styles.button} type="primary" onClick={onSubmit}>
          去编辑
        </Button>
      </div>
    </HBModal>
  );
}

export default ModalWrap(MaterialFileTypeSelectModal);
